import React, { useState, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  // Smooth scroll to section
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -80; // navbar height offset
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    closeMenu();
  };

  // Navbar background on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      {/* Logo */}
      <div className="navbar-logo">
        <h1 className="cctextlogo">
          Cosmical Calculator 
        </h1>
      </div>

      {/* Desktop Links */}
      <ul className="nav-links desktop-only">
        <a href="/"><li><button className="nav-btn" >Home</button></li></a>
        {/* <a href="/about"><li><button className="nav-btn" >About</button></li></a> */}
       
       
       
        
       {/* <a href="Service"> <li><button className="nav-btn"  >Services</button></li></a> */}
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("services")}>Services</button></li> */}
       <a href="Time-Rectification"> <li><button className="nav-btn" >Speciality</button></li></a>
       <a href="Service"> <li><button className="nav-btn" >Compatability Matching</button></li></a>
       <a href="Horoscope"> <li><button className="nav-btn" >Horoscope</button></li></a>
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("career")}>Compatibility Match</button></li> */}
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("stats")}>Stats</button></li> */}
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("appointment")}>Appointment</button></li> */}
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("membership")}>Membership</button></li> */}
        {/* <li><button className="nav-btn" onClick={() => scrollToSection("testimonials")}>Testimonials</button></li> */}
        {/* <li>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSe8yaRiwCVLHKYHZvyg-pO4sJkBLZ5v0acGBzzeDzlENrLIpg/viewform?usp=header" target="_blank" rel="noopener noreferrer" className="join-us-btn-navbar-extra">
            Crystals
          </a>
        </li> */}
        <li>
          <a href="Book-your-slot" target="_blank" rel="noopener noreferrer" className="join-us-btn-navbar-extra">
            Book Consultation
          </a>
        </li>
      </ul>

      {/* Hamburger */}
      <button className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeMenu}>×</button>
        <ul className="mobile-links">
          <a href="/"><li><button className="mobile-btn">Home</button></li></a>
          <li><button className="mobile-btn" onClick={() => scrollToSection("services")}>Services</button></li>
        <a href="Time-Rectification"> <li><button className="mobile-btn" >Speciality</button></li></a> 
          <li><button className="mobile-btn" onClick={() => scrollToSection("career")}>Compatibility Match</button></li>
          {/* <li><button className="mobile-btn" onClick={() => scrollToSection("horoscope")}>Horoscope</button></li> */}
          {/* <li><button className="mobile-btn" onClick={() => scrollToSection("stats")}>Stats</button></li> */}
          <li><button className="mobile-btn" onClick={() => scrollToSection("appointment")}>Appointment</button></li>
          {/* <li><button className="mobile-btn" onClick={() => scrollToSection("membership")}>Membership</button></li> */}
          {/* <li><button className="mobile-btn" onClick={() => scrollToSection("testimonials")}>Testimonials</button></li> */}
          <li>
            <a href="Book-your-slot" target="_blank" rel="noopener noreferrer" className="join-us-btn-mobile">
              Book Consultation
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
